import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "../components/Common/Header/Header";
import Footer from "../components/Common/Footer";
import "./pageCSS/HighCourt.css";
import Button from "../components/Common/Button/Button";
import axios from "axios";
import { useForm } from "react-hook-form";

const HighCourtSR = () => {
  const [title, setTitle] = useState("");
  const location = useLocation();

  // using hook form
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    console.log(data);
    const formData = new FormData();

    for (const key in data) {
      formData.append(key, data[key]);
    }
    formData.append("image", data.image[0]);
    try {
      await axios
        .post(
          "https://lawacademyadmin.icicle.dev/api/highCourtRegister",
          formData
        )
        .then((res) => {
          if (res.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Register successfully!",
              text: "To confirm your admission, visit our office",
              showConfirmButton: true,
              color: "success",
            });
          }
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: `${error.response.data.errors.confirm_password}`,
        showConfirmButton: true,
        color: "error",
      });
    }
  };

  // another solution
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const data = JSON.parse(searchParams.get("data"));

    setTitle(data);
  }, [location]);
  return (
    <div className="">
      <Header />
      <div className="">
        <div
          className="high_court_section "
          style={{ border: "1px solid gray" }}
        >
          <form
            className=""
            onSubmit={handleSubmit(onSubmit)}
            style={{ padding: "30px" }}
          >
            <h3 style={{ marginBottom: "30px" }}>{title}</h3>

            <div className="form-container">
              <div style={{ display: "none" }}>
                <input
                  className="hover-border"
                  name="high_court"
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                    display: "none",
                  }}
                  type="text"
                  defaultValue="1"
                />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Name:{" "}
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <input
                  className="hover-border"
                  name="name"
                  {...register("name", { required: true })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Name"
                />
                {errors.name && (
                  <span style={{ color: "red" }}>Name is required</span>
                )}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Father's Name:
                </label>
                <input
                  className="hover-border"
                  name="fathers_name"
                  {...register("fathers_name")}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Father's Name"
                />
                {errors.fathers_name && (
                  <span style={{ color: "red" }}>
                    Father's Name is required
                  </span>
                )}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Mother's Name:
                </label>
                <input
                  className="hover-border"
                  name="mothers_name"
                  {...register("mothers_name")}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Mother's Name"
                />
                {/* {errors.mothers_name && (
                  <span style={{ color: "red" }}>
                    Mother's Name is required
                  </span>
                )} */}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Personal Contact Number:{" "}
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <input
                  className="hover-border"
                  name="phone"
                  {...register("phone", { required: true })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="number"
                  placeholder="Enter Contact Number"
                />
                {errors.phone && (
                  <span style={{ color: "red" }}>
                    Personal Contact Number is required
                  </span>
                )}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Emergency Contact Numbers:{" "}
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <input
                  className="hover-border"
                  name="emergency_phone"
                  {...register("emergency_phone", { required: true })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="number"
                  placeholder="Enter Emergency Contact "
                />
                {errors.emergency_phone && (
                  <span style={{ color: "red" }}>
                    Emergency contact Number is required
                  </span>
                )}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Relation To Emergency Contact:
                </label>
                <input
                  className="hover-border"
                  name="relation"
                  {...register("relation")}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="number"
                  placeholder="Enter Relation To Emergency"
                />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Email:
                </label>
                <input
                  className="hover-border"
                  name="email"
                  {...register("email")}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Email"
                />
                {errors.email && (
                  <span style={{ color: "red" }}>Email is required</span>
                )}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Date of Birth:{" "}
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <input
                  className="hover-border"
                  name="birth_date"
                  {...register("birth_date", { required: true })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="date"
                  placeholder="Enter Contact Number"
                />
                {errors.birth_date && (
                  <span style={{ color: "red" }}>
                    Date of Birth is required
                  </span>
                )}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Gender:{" "}
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <select
                  className="hover-border"
                  name="gender"
                  {...register("gender", { required: true })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                >
                  <option value="" hidden>
                    Select Gender
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
                {errors.gender && (
                  <span style={{ color: "red" }}>Gender is required</span>
                )}
              </div>

              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  University (LLB) :{" "}
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <input
                  className="hover-border"
                  name="university"
                  {...register("university", { required: "true" })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Your University"
                />
                {errors.university && (
                  <span style={{ color: "red" }}>University is required</span>
                )}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Qualified Year (LLB) :{" "}
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <input
                  className="hover-border"
                  name="qualified_year"
                  {...register("qualified_year", { required: true })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Qualified Year (LLB)"
                />
                {errors.qualified_year && (
                  <span style={{ color: "red" }}>
                    Qualified Year is required
                  </span>
                )}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  GPA (LLB):
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <input
                  className="hover-border"
                  name="gpa"
                  {...register("gpa", {
                    required: true,
                    pattern: /^\d+(\.\d{0,2})?$/,
                  })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Your GPA (LLB)"
                />
                {errors.gpa && errors.gpa.type === "pattern" && (
                  <span style={{ color: "red" }}>Please enter a valid GPA</span>
                )}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  University (LLM) (Optional) :
                </label>
                <input
                  className="hover-border"
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Your University"
                />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Passing Year (LLM) (Optional):
                </label>
                <input
                  className="hover-border"
                  name="qualified_year_llm"
                  {...register("qualified_year_llm")}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Passing Year (LLM)"
                />
              </div>

              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  GPA (LLM) (Optional):
                </label>
                <input
                  className="hover-border"
                  name="gpa_llm"
                  {...register("gpa_llm")}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Your GPA (LLM)"
                />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Referred by:
                </label>
                <input
                  className="hover-border"
                  name="referred_by"
                  {...register("referred_by")}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Name"
                />
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Court Practice: <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <select
                  className="hover-border"
                  name="court_practice"
                  {...register("court_practice", { required: true })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                >
                  <option value="" hidden>
                    Select Court Practice
                  </option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </select>
              </div>

              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Address:{" "}
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <input
                  className="hover-border"
                  name="address"
                  {...register("address", { required: true })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="text"
                  placeholder="Enter Address"
                />
                {errors.address && (
                  <span style={{ color: "red" }}>Address is required</span>
                )}
              </div>
              
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Password:
                </label>
                <input
                  className="hover-border"
                  name="password"
                  {...register("password")}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="password"
                  placeholder="Enter Password"
                />
                {/* {errors.password && (
                  <span style={{ color: "red" }}>Password is required</span>
                )} */}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Confirm Password:
                </label>
                <input
                  className="hover-border"
                  name="confirm_password"
                  {...register("confirm_password")}
                  style={{
                    width: "100%", 
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="password"
                  placeholder="Confirm Password"
                />
                {errors.confirm_password && (
                  <span style={{ color: "red" }}>
                    Confirm Password is required
                  </span>
                )}
              </div>
              <div>
                <label style={{ display: "block", marginBottom: "5px" }}>
                  Image:{" "}
                  <span style={{ color: "red", fontSize: "16px" }}>*</span>
                </label>
                <input
                  className="hover-border"
                  name="image"
                  {...register("image", { required: true })}
                  style={{
                    width: "100%",
                    marginBottom: "10px",
                    padding: "10px",
                  }}
                  type="file"
                  placeholder="Confirm Password"
                />
                {errors.image && (
                  <span style={{ color: "red" }}>Image is required</span>
                )}
              </div>
            </div>
            <div className="col-12" style={{ marginTop: "15px" }}>
              <Button title={"Register Now"}></Button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HighCourtSR;
